// extracted by mini-css-extract-plugin
export default {"container":"DocumentControls_container__cxuVt"};